import styled from "styled-components"

const Component = styled.div`
  background-color: #fff;
`
export const Layout = Component
